const ABFieldCore = require("../../core/dataFields/ABFieldCore");
module.exports = class ABField extends ABFieldCore {};
